module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAABJElEQVQ4T6WUu0oDQRSGvz95BisfwBew1zIpbFJY6WajYMRCFOwUEcTSWgSJBhufIJ2X0lpIYZVCwcbCeAGFJCMnJiC62c3OnmYY5v+/M3Auou4mgUtgip94BzYp62Rwjz3EmTtFhBGqfcraTYKIursBZkYIa7SosqfOKJD94BoxG5Ppik9KVNWO0owDMF+TLkWW9PAXMi7AfI84CoRq/oakAZjvlTwlFmRV60dagHm6wOqwzD6AYfJ+mbMADLSdFfCWDeBoZwPAhj/AsUWow/QAxxc5QgJd+PTBMz3mqOjWp5FadCiyrHufVr4jR4FFPfkMUwMxT6CP6HGOWyjiiEBrcVvJqnCMWPknEjsEOkheaTU3QZ4GMD0Qv9BjnYrOk8z2/g1AEWxhdEnYbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/questioSanjiao.png
// module id = z4+h
// module chunks = 0